<div class="close closeModal">
  <a (click)="close(true)" title="cerrar"
    ><span class="cross"></span><span class="sr-only">cerrar</span></a
  >
</div>
<div class="aviso facturacion">
  <div class="tituloSearch">
    {{ 'NOMINAR_ENTRADAS' | translateV2 }} - {{ nombresEntradas[pager.currentPage - 1] }}
    {{ rangoEntradas[pager.currentPage - 1] }}
  </div>

  <div class="avisoInputWrap">
    <div>
      <ul class="pagination" *ngIf="pager.pages && pager.pages.length !== 0">
        <li>
          <a (click)="setPage(pager.currentPage - 1)" title="Previo">
            <img
              class="svg"
              src="assets/img/active-arrow.svg"
              alt="icono prev"
            />
          </a>
        </li>
        <li *ngFor="let page of pager.pages">
          <a
            (click)="setPage(page)"
            [ngClass]="{ active: pager.currentPage === page }"
            >{{ page }}</a
          >
        </li>
        <li>
          <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
            <img
              class="svg"
              src="assets/img/active-arrow.svg"
              alt="icono next"
            />
          </a>
        </li>
      </ul>
    </div>

    <div>
      <form [formGroup]="form">
        <div
          class="flex-container"
          formArrayName="entradas"
          *ngFor="let entradas of pagedItems; let indiceE = index"
        >
          <div
            style="width: 48%"
            class="form-group"
            [formGroupName]="pager.currentPage - 1"
            *ngFor="
              let field of formulariosGenerados[pager.currentPage - 1];
              let idx = index
            "
          >
            <label class="tit-form-group" [attr.for]="field.label">{{
              field.label
            }}</label>
            <div [ngSwitch]="field.type">
              <input
                class="form-control"
                *ngSwitchCase="'input'"
                [formControlName]="field.name"
                [type]="field.inputType"
                [attr.busqueda]="field.busqueda"
              />
              <img
                class="svg icon"
                src="assets/img/icon-search.svg"
                alt="icono search"
                (click)="abrirBusqueda(field, entradas)"
                *ngIf="field.busqueda"
              />

              <select
                class="form-control"
                [id]="field.name"
                *ngSwitchCase="'select'"
                [formControlName]="field.name"
                (change)="
                  controlCambioSelects(
                    field,
                    $event.target,
                    pager.currentPage - 1
                  )
                "
              >
                <!-- [value]="field.value" -->
                <option
                  class="form-control"
                  *ngFor="let opt of getOptions(field.options)"
                  [value]="opt"
                >
                  {{ opt }}
                </option>
              </select>

              <mat-radio-group
                color="accent"
                class="tit-form-group flex-radio"
                *ngSwitchCase="'radiobutton'"
                [formControlName]="field.name"
                [value]="field.value"
              >
                <mat-radio-button
                  *ngFor="let opt of field.options"
                  [value]="opt"
                  >{{ opt }}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="BuscarClienteFacturacion" *ngIf="abrir" style="width: 90%">
          <!-- <div class="inpuSearch">
            <input type="text" id="search_field" formControlName="nombre" />
            <div class="close" (click)="abrir = false">
              <a title="borrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
            </div>
          </div> -->
          <div
            class="close"
            (click)="abrir = false"
            style="position: relative; left: 95%"
          >
            <a title="borrar"
              ><span class="cross"></span><span class="sr-only">cerrar</span></a
            >
          </div>
          <div class="listaPredicc" *ngIf="contactos">
            <div class="Rtable">
              <div class="Rtable-row Rtable-row--head">
                <div class="Rtable-cell cliente-cell column-heading">
                  {{ 'NOMBRE' | translateV2 }}
                </div>
                <div class="Rtable-cell legal-cell column-heading">
                  {{ 'CONTACTO_INFO' | translateV2 }}
                </div>
                <div class="Rtable-cell num-cell column-heading">
                  {{ 'CLIENTE_DNI_CIF' | translateV2 }}
                </div>
              </div>
              <div
                class="Rtable-row"
                (click)="seleccionarContacto(cliente)"
                *ngFor="let cliente of pagedItemsContactos"
              >
                <div class="Rtable-cell cliente-cell">
                  <div class="Rtable-cell--content cliente-content">
                    {{ cliente.Nombre }}
                  </div>
                </div>
                <div class="Rtable-cell legal-cell">
                  <div class="Rtable-cell--content legal-content">
                    {{ cliente.Contacto }}
                  </div>
                </div>
                <div class="Rtable-cell num-cell">
                  <div class="Rtable-cell--content num-content">
                    {{ cliente.Cif }}
                  </div>
                </div>
              </div>
            </div>
            <ul
              class="pagination"
              *ngIf="pagerContactos.pages && pagerContactos.pages.length > 1"
            >
              <li>
                <a
                  (click)="setPageContacto(pagerContactos.currentPage - 1)"
                  title="Previo"
                >
                  <img
                    class="svg"
                    src="assets/img/active-arrow.svg"
                    alt="icono prev"
                  />
                </a>
              </li>
              <li *ngFor="let page of pagerContactos.pages">
                <a
                  (click)="setPageContacto(page)"
                  [ngClass]="{ active: pagerContactos.currentPage === page }"
                  >{{ page }}</a
                >
              </li>
              <li>
                <a
                  (click)="setPageContacto(pagerContactos.currentPage + 1)"
                  title="Próximo"
                >
                  <img
                    class="svg"
                    src="assets/img/active-arrow.svg"
                    alt="icono next"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </form>
      <div class="faturacion-fila">
        <div class="ticket-info">
          <div class="inputControl botones">
            <button
              type="button"
              value="cancelar"
              class="cancelar"
              (click)="close(true)"
            >
              {{ 'CANCELAR' | translateV2 }}
            </button>
          </div>
        </div>
        <div class="ticket-info">
          <div class="inputControl botones">
            <button
              type="button"
              value="ACEPTAR"
              class="pagar aceptar"
              (click)="continuar()"
              [disabled]="!validadorEdadXanno() || form.invalid"
            >
              {{ 'ACEPTAR' | translateV2 }}
            </button>
          </div>
        </div>
        <div class="ticket-info">
          <div class="inputControl botones">
            <button
              type="button"
              value="COPIAR ANTERIOR"
              class="pagar info"
              (click)="copiarAnterior(pager.currentPage - 1)"
              [hidden]="valorAnterior()"
            >
              {{ 'COPIAR_ANTERIOR' | translateV2 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="keyboardWrap">
  <ticketing-keyboard></ticketing-keyboard>
  <ticketing-numpad></ticketing-numpad>
</div>
